import React from 'react';
import '../../styles/onboardingFlow/onboardingComponents/sidebarCard.scss';
import CheckCircleBlue from '../../assets/onboarding/common/CheckCircleBlue.svg';
import CheckCircleBlack from '../../assets/onboarding/common/CheckCircleBlack.svg';
import CircleOutline from '../../assets/onboarding/common/CircleOutline.svg';

interface SidebarCardProps {
  stepNumber: number;
  title: string;
  subtitle: string;
  isActive: boolean;
  isCompleted: boolean;
  isDisabled?: boolean;
  onClick: () => void;
}

const SidebarCard: React.FC<SidebarCardProps> = ({
  stepNumber,
  title,
  subtitle,
  isActive,
  isCompleted,
  isDisabled = false,
  onClick,
}) => {
  const getIcon = () => {
    if (isActive) {
      return CheckCircleBlue;
    }
    if (isCompleted) {
      return CheckCircleBlack;
    }
    return CircleOutline;
  };

  return (
    <div
      className={`sidebarCard ${isActive ? 'sidebarCard--active' : ''} ${
        isCompleted && !isActive ? 'sidebarCard--completed' : ''
      } ${!isActive && !isCompleted ? 'sidebarCard--inactive' : ''} ${
        isDisabled ? 'sidebarCard--disabled' : ''
      }`}
      onClick={isDisabled ? undefined : onClick}
    >
      <div className='sidebarCard__icon'>
        <img src={getIcon()} alt={`Step ${stepNumber}`} />
      </div>
      <div className='sidebarCard__content'>
        <h3 className='sidebarCard__title'>{title}</h3>
        <p className='sidebarCard__subtitle'>{subtitle}</p>
      </div>
    </div>
  );
};

export default SidebarCard;
